var exports = {
  "kL": "x804f0401--028e54--container",
  "DD": "x804f0401--028e54--title",
  "UU": "x804f0401--028e54--name",
  "VQ": "x804f0401--028e54--ratings",
  "O0": "x804f0401--028e54--rating",
  "VA": "x804f0401--028e54--subtitle",
  "lI": "x804f0401--028e54--fieldset",
};

module.exports = exports;
